import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import Logo from '../components/Logo';

const menuLinks = ['Home', 'Note', 'Methodology'];

const Header = () => {
  const location = useLocation().pathname;

  return (
    <>
      <header
        role="banner"
        className="flex flex-row flex-wrap justify-center pt-6 space-x-3 text-sm font-mono text-white"
      >
        {menuLinks.map((item, index) => {
          return (
            <nav role="navigation" key={index}>
              {item === 'Home' ? (
                <Link
                  to={`/`}
                  className={`${
                    location === '/' ? 'text-yellow-500 font-bold' : 'underline'
                  }`}
                  alt={item}
                >
                  {item}
                </Link>
              ) : (
                <Link
                  to={`/${item.toLowerCase()}`}
                  className={`${
                    (location === '/note' && item === 'Note') ||
                    (location === '/methodology' && item === 'Methodology')
                      ? 'text-yellow-500 font-bold'
                      : 'underline'
                  }`}
                  alt={item}
                >
                  {item}
                </Link>
              )}{' '}
              {index !== menuLinks.length - 1 && '|'}
            </nav>
          );
        })}
      </header>
      <Logo />
    </>
  );
};

export default Header;
